import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$7 } from './avatar.js';
import { d as defineCustomElement$6 } from './button.js';
import { d as defineCustomElement$5 } from './dropdown.js';
import { d as defineCustomElement$4 } from './grid.js';
import { d as defineCustomElement$3 } from './icon.js';
import { d as defineCustomElement$2 } from './spinner.js';

const profileButtonCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}:host{display:inline-block;cursor:pointer}tt-avatar{--size:2em}";

const ProfileButton = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.profile = undefined;
  }
  connectedCallback() {
    this.profile = {
      name: 'Philip Nielsen',
      email: 'philip@twentythree.net',
      image: 'https://rangu.23demo.com/files/avatar/4701707/buddy.gif',
    };
  }
  render() {
    return (h("tt-dropdown", null, h("div", { slot: "trigger" }, h("tt-avatar", { image: "https://rangu.23demo.com/files/avatar/4701707/buddy.gif" })), h("tt-grid", null, h("tt-row", null, h("tt-col", null, h("tt-avatar", { image: "https://rangu.23demo.com/files/avatar/4701707/buddy.gif" })), h("tt-col", null, this.profile.name), h("tt-col", null, h("tt-button", { size: "small", variant: "light" }, "Manage")), h("tt-col", null, h("tt-button", { size: "small", variant: "light" }, h("tt-icon", { name: "switch-off", library: "23" }), "Log out"))))));
  }
  static get style() { return profileButtonCss; }
}, [1, "tt-profile-button", {
    "profile": [32]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-profile-button", "tt-avatar", "tt-button", "tt-dropdown", "tt-grid", "tt-icon", "tt-spinner"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-profile-button":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ProfileButton);
      }
      break;
    case "tt-avatar":
      if (!customElements.get(tagName)) {
        defineCustomElement$7();
      }
      break;
    case "tt-button":
      if (!customElements.get(tagName)) {
        defineCustomElement$6();
      }
      break;
    case "tt-dropdown":
      if (!customElements.get(tagName)) {
        defineCustomElement$5();
      }
      break;
    case "tt-grid":
      if (!customElements.get(tagName)) {
        defineCustomElement$4();
      }
      break;
    case "tt-icon":
      if (!customElements.get(tagName)) {
        defineCustomElement$3();
      }
      break;
    case "tt-spinner":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const TtProfileButton = ProfileButton;
const defineCustomElement = defineCustomElement$1;

export { TtProfileButton, defineCustomElement };
